import { Injectable, inject } from '@angular/core';
import { RdrAuthService } from '@auth/services/rdr-auth.service';
import { NavigationKey } from '@app/generated/graphql';
import { Observable, map, shareReplay } from 'rxjs';

/**
 * EC-338 / Permission v1 Wave 8: `userAuth.navigation` (Pattern 4).
 *
 * The backend answers *which* routes, menu items and sections are visible; paths, labels,
 * icons and which surface a key renders in stay here. A key only says the section is
 * reachable — every read/write inside it is still capability-checked server-side.
 */
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private authService = inject(RdrAuthService);

  userAuth$ = this.authService.getUser().pipe(shareReplay({ bufferSize: 1, refCount: true }));

  navigation$: Observable<NavigationKey[]> = this.userAuth$.pipe(
    map((user) => user?.navigation ?? []),
  );

  hasKey$(key: NavigationKey): Observable<boolean> {
    return this.navigation$.pipe(map((keys) => keys.includes(key)));
  }
}
